import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@knockrentals/knock-shared-web-v2';
import ImageManager from './ImageManager';
import { IMAGE_DIALOG_TYPES } from '../constants';

const ImageDialog = ({ closeDialog, images, isOpen, type, updateImages }) => {
  return (
    <Dialog
      fullWidth
      maxWidth={type === IMAGE_DIALOG_TYPES.LOGO ? 'sm' : 'md'}
      onClose={closeDialog}
      open={isOpen}
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
    >
      <ImageManager
        images={images}
        closeDialog={closeDialog}
        dialogType={type}
        updateImages={updateImages}
      />
    </Dialog>
  );
};

ImageDialog.propTypes = {
  closeDialog: PropTypes.func,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      url: PropTypes.string,
      clUrl: PropTypes.string,
      thumbUrl: PropTypes.string,
    }),
  ),
  isOpen: PropTypes.bool,
  type: PropTypes.oneOf([IMAGE_DIALOG_TYPES.LOGO, IMAGE_DIALOG_TYPES.PHOTOS]),
  updateImages: PropTypes.func,
};

export default ImageDialog;
